module.exports = __webpack_public_path__ + "img/story024@2x.3d51c8d6.webp";